import { isFunction } from 'angular';
var SearchSorterComponentController = (function () {
    function SearchSorterComponentController() {
        this.emptySorter = {
            sortingExpression: null,
            title: '',
        };
    }
    SearchSorterComponentController.prototype.$onInit = function () {
        this.sorters = this.sorters === undefined ? [] : this.sorters;
    };
    SearchSorterComponentController.prototype.$onChanges = function () {
        this.selectedSorter = this.initiallySelectedSorter || this.sorters[0] || this.emptySorter;
    };
    SearchSorterComponentController.prototype.onSortChanged = function () {
        if (!isFunction(this.onSortChange)) {
            return;
        }
        this.onSortChange({ sorter: this.selectedSorter });
    };
    SearchSorterComponentController.$inject = [];
    return SearchSorterComponentController;
}());
export var SearchSorterComponent = {
    bindings: {
        initiallySelectedSorter: '<',
        label: '<?',
        onSortChange: '&?',
        sorters: '<',
    },
    controller: SearchSorterComponentController,
    template: "\n    <span class=\"search-sorter__label\" ng-bind=\"$ctrl.label\" ng-if=\"$ctrl.label\"></span>\n    <select ng-model=\"$ctrl.selectedSorter\" \n            ng-change=\"$ctrl.onSortChanged()\" \n            ng-options=\"sorter.title for sorter in $ctrl.sorters\"\n            ng-if=\"$ctrl.sorters.length > 0\">\n    </select>\n  ",
};
